<template>
  <el-menu
    class="mobile-menu__utility"
    mode="vertical"
    :default-active="$route.path"
    :router="true"
  >
    <el-menu-item
      v-for="(item, key) in utilityLinks"
      :key="key"
      :index="{ name: item.url }"
    >
      <span>
        {{ item.title }}
      </span>
    </el-menu-item>
    <!-- 
    <el-menu-item class="offline-indicator" :class="isOnline ? 'online' : 'offline'">
      {{ isOnline? $t('onlineMode'): $t('offlineMode') }}
    </el-menu-item>
     -->
    <el-menu-item v-if="supportedFeaturesOutbox" class="outbox" index="/outbox">
      <span class="el-icon-custom-mail outbox-icon">
        <span v-show="hasAssets" class="outbox-notification">{{
          assetCount
        }}</span>
        {{ $t('menuOutbox') }}
      </span>
    </el-menu-item>
    <el-menu-item index="/search" class="search">
      <el-form @submit.native.prevent="onSubmit">
        <el-input
          v-model="searchQuery"
          :placeholder="$t('menuSearch')"
          suffix-icon="el-icon-custom-magnify"
        />
      </el-form>
    </el-menu-item>
  </el-menu>
</template>

<script>
import mixins from '@/mixins';
import navigation from '@/components/navigation';
import offline from '@/offline';
import outbox from '@/components/outbox';
import router from '@/router';
import user from '@/components/user';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'NavMobileUtility',
  props: {},
  data: () => {
    return {
      searchQuery: '',
      expandedSubmenu: null,
    };
  },
  mixins: [mixins.supportedFeatures],
  watch: {
    active(newActive, oldActive) {
      if (oldActive && !newActive) {
        // This is slightly larger than the transition duration
        // to ensure that the transition completes before we revert state
        setTimeout(() => (this.expandedSubmenu = null), 225);
      }
    },
  },
  computed: {
    ...mapState(user.store.namespace, ['currentUser']),
    ...mapGetters(user.store.namespace, ['region']),
    ...mapState(offline.store.namespace, ['isOnline']),
    ...mapGetters(outbox.store.namespace, ['hasAssets', 'assetCount']),
    ...mapState(navigation.store.namespace, ['utilityLinks']),
  },
  methods: {
    onSubmit() {
      if (this.searchQuery && this.searchQuery.trim().length > 0) {
        const query = this.searchQuery.trim();
        this.searchQuery = '';
        router.push({ name: 'Search', params: { searchQuery: query } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/base/_variables.scss';

.mobile-menu__utility {
  background-color: $--color-black;
  padding-bottom: 1rem;

  &:deep(.el-menu-item),
  &:deep(.el-menu-item) > a,
  &:deep(.el-menu-item) > span {
    color: $--color-white;
  }

  & > .el-menu-item {
    margin-left: 1rem;
    margin-right: 1rem;
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
    border-bottom: solid 1px $--color-white;

    &.search {
      display: block;
      padding: 0 !important;
      border-bottom: none;
      background-color: $--color-black;

      &.is-active {
        background-color: $--color-black;
      }

      &:deep(i) {
        padding-top: 2px;
        font-size: 18px;
        color: $--color-primary;
      }

      &:deep(input) {
        margin-top: -5px;
        height: 57px;
        font-family: $font-family-headings;
        font-weight: bold;
        font-size: 14px;
        text-transform: uppercase;
        color: $--color-secondary;

        &::placeholder {
          color: $--color-menu-gray;
        }

        &:focus {
          border-color: $--color-primary;
          outline: 1px solid $--color-primary;
        }
      }
    }
  }

  &:deep(.el-icon-custom-mail) {
    .outbox-notification {
      position: relative;
      right: 5px;
      bottom: -8px;
      border-radius: 50%;
      width: 1rem;
      height: 1rem;
      padding: 0.2rem;
      background-color: $--color-primary;
      color: $--color-white;
      margin-right: -5px;
    }
  }
}
</style>
